import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import swal from 'sweetalert';

import CRMApi from '../../../Api/CRM/CRMApi';
import Card from '../../elements/common/Card';
import handleValidationErrors from '../../helpers/ResponseErrorHelper';
import { StringParams } from '../../helpers/types';
import axios from '../../services/MyAxios';

function AddFaqToCategory() {
    const history = useHistory();
    const { id } = useParams<StringParams>();
    const [faqs, setFaqs] = useState<{ id: string; question: string; is_agent: boolean }[]>([]);
    const [selectedFaq, setSelectedFaq] = useState<string>('');
    const url = `/crea/api/faq_category/${id}`;

    const handleAdd = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        try {
            await axios.post(`${url}/add_faq`, { faqId: Number(selectedFaq) });
            await swal({
                title: 'Success',
                text: 'Faqs was added to category correctly',
                icon: 'success',
            });
            history.push(`/faq_category/${id}`);
        } catch (error) {
            handleValidationErrors(error, (errors: any) => {
                console.error('Validation errors:', errors);
            });
        }
    };

    const handleFaqChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedFaq(event.target.value);
    };

    useEffect(() => {
        const fetchFaqs = async () => {
            const numericId = Number(id);
            const faqsData = await CRMApi.faqCategories.getNotAddedFaqs(numericId);

            const formattedFaqs = faqsData.map((faq: any) => ({
                id: String(faq.id),
                question: faq.question,
                is_agent: faq.is_agent,
            }));
            setFaqs(formattedFaqs);
        };

        fetchFaqs();
    }, []);

    return (
        <Card title="Add FAQ">
            <form onSubmit={handleAdd}>
                <div className="form-group">
                    <label htmlFor="faq">FAQ</label>
                    {faqs.length > 0 ? (
                        <select
                            id="faq"
                            className="form-control"
                            name="faq"
                            value={selectedFaq}
                            onChange={handleFaqChange}
                        >
                            <option value="">Select a FAQ</option>

                            {faqs.some((faq) => faq.is_agent) && (
                                <optgroup label="Agents FAQ">
                                    {faqs
                                        .filter((faq) => faq.is_agent)
                                        .map((faq) => (
                                            <option key={faq.id} value={faq.id}>
                                                {faq.question}
                                            </option>
                                        ))}
                                </optgroup>
                            )}

                            <optgroup label="General FAQ">
                                {faqs
                                    .filter((faq) => !faq.is_agent)
                                    .map((faq) => (
                                        <option key={faq.id} value={faq.id}>
                                            {faq.question}
                                        </option>
                                    ))}
                            </optgroup>
                        </select>
                    ) : (
                        <p>Loading FAQs...</p>
                    )}
                </div>
                <button type="submit" className="btn btn-primary">
                    Add FAQ
                </button>
            </form>
        </Card>
    );
}

export default AddFaqToCategory;
